import { memo } from "react";
import { Switch, Route as ReactRouterRoute } from "react-router-dom";

import { isMainRoute } from "../utilities/matchers";

import { RouteType } from "./enums";
import { Routes } from "./types";

const routingMap = new Map();

type RouterProps = {
  readonly routes: Routes;
};

const generateRoutingMap = (routes: Routes): void => {
  routes.forEach((route) => {
    if (route.routes && route.type === RouteType.MAIN_ROUTE) {
      generateRoutingMap(route.routes);
    }

    isMainRoute(route) &&
      routingMap.set(
        [route.name, route.path].join("-"),
        <ReactRouterRoute
          exact
          path={route.path}
          key={[route.name, route.path].join("-")}
        >
          <route.component {...route.props} />
        </ReactRouterRoute>
      );
  });
};

function areRoutesEqual(
  prevProps: RouterProps,
  nextProps: RouterProps
): boolean {
  return prevProps.routes === nextProps.routes;
}

export const Router = memo<RouterProps>(({ routes }) => {
  generateRoutingMap(routes);

  return <Switch>{[...routingMap]}</Switch>;
}, areRoutesEqual);
